import styled from "styled-components";

export const CardContainer = styled.div`
  * {
    margin: 0;
    padding: 0;
  }
  ${({ theme }) =>
    `
    font-family: ${theme.font.primary};
  `}
  display: flex;
  flex-direction: column;
  padding: 32px 22px;
  background: #ffffff;
  border: 1px solid #e4e7ec;
  box-sizing: border-box;
  border-radius: 6px;
  height: 100%;
  &:hover {
    box-shadow: 0px 4px 30px rgba(0, 0, 0, 0.1);
  }
`

export const ImageWrapper = styled.div`
  height: 127px;
  width: 100%;
  object-fit: contain;
  margin: 32px 0 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  .gatsby-image-wrapper {
    width: 100%;
    margin: auto 0;
    img {
      margin: 0 auto;
      width: auto;
      max-width: 100%;
      max-height: 127px;
    }
  }
`